import {genSortedDocs} from './generic';

const {docs: discounts, loaded, sort, sorted} = genSortedDocs('discounts');

export default {discounts, loaded, sort, sorted};